module.exports = __webpack_public_path__ + "media/images/start_header_default-2b3670c8058939a55f9afb02eb17fa30.webp";